import uploadcare from 'uploadcare-widget';

window.uploadcare = uploadcare;
window.UPLOADCARE_PUBLIC_KEY = process.env.UPLOADCARE_PUBLIC_KEY;
